export default "__VITE_ASSET__BagW3D6H__"